export const GET_BANK_CORESPONDENTS = "GET_BANK_CORESPONDENTS";
export const SET_BANK_CORESPONDENTS = "SET_BANK_CORESPONDENTS";

export const ADD_BANK_CORESPONDENT = "ADD_BANK_CORESPONDENT";
export const UPDATE_BANK_CORESPONDENT = "UPDATE_BANK_CORESPONDENT";
export const DELETE_BANK_CORESPONDENT = "DELETE_BANK_CORESPONDENT";

export const BANK_CORESPONDENTS_LOADING = "BANK_CORESPONDENTS_LOADING";
